import { IOptionItem } from "@/components/ui/dropdown/types";

export type DataSettings = {
  country?: IOptionItem;
  spatialAggregation?: {
    type?: IOptionItem;
    adminAreaAttribute?: string;
    point?: {
      pointType?: IOptionItem;
      pointCoordinate?: {
        latAttribute?: IOptionItem;
        longAttribute?: IOptionItem;
      };
      geocodingAtrtribute?: string;
    };
    pointAttribute?: string;
    polygonAttribute?: string;
  };
};

export enum EDataSettingPopupType {
  Single = "Single",
  Multiple = "Multiple",
  None = "None"
}

export type DataSettingPopupType =
  | EDataSettingPopupType.Single
  | EDataSettingPopupType.Multiple
  | EDataSettingPopupType.None;

export enum EDataSettingSpatialType {
  Admin_Area = "admin_area",
  Point = "poi",
  Polygon = "polygon"
}

export type DataSettingSpatialType =
  | EDataSettingSpatialType.Admin_Area
  | EDataSettingSpatialType.Point;

export enum EDataSettingPointType {
  Coordinate = "coordinate",
  Geocoding = "geocoding"
}

export type DataSettingPointType =
  | EDataSettingPointType.Coordinate
  | EDataSettingPointType.Geocoding;

// Mock Payload, will update in integrate API ticket
export interface DataSettingPayload {
  datasetId: string;
  country?: string;
  type: string;
}
